import { render, staticRenderFns } from "./approve-detail-comic.vue?vue&type=template&id=02fc92be"
import script from "./approve-detail-comic.vue?vue&type=script&lang=tsx"
export * from "./approve-detail-comic.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports